import React from 'react';
import { STAR } from '../../../constants';
import StarRatings from 'react-star-ratings';

export default function ProductName({ name, rating }) {
  return (
    <>
      <h1
        className="product-title"
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 0,
          paddingBottom: Number(rating) > 0 ? 5 : 20
        }}>
        {name}
        {Number(rating) > 0 && (
          <StarRatings
            name="rating"
            rating={Number(rating)}
            starDimension={'25'}
            numberOfStars={STAR.NUMBER_OF_STAR}
            starRatedColor={STAR.RATED_COLOR}
            starEmptyColor={STAR.EMPTY_COLOR}
            starSpacing={STAR.SPACING}
            svgIconPath={STAR.svgIconPath}
            disabled
          />
        )}
      </h1>
    </>
  );
}
